import React from 'react'
import { useServerContext } from 'next-server-context'

import PublicLayout from 'components/PublicLayout/PublicLayout'

import NotFound from './NotFound'

interface NotFoundPageProps {
  title: string
  subTitle: string
  backButtonText: string
  backButtonHref: string
}

const NotFoundPage: React.FC<NotFoundPageProps> = ({
  title,
  subTitle,
  backButtonText,
  backButtonHref,
}) => {
  const serverContext = useServerContext()

  if (serverContext) serverContext.response.statusCode = 404

  return (
    <PublicLayout>
      <NotFound
        backButtonHref={backButtonHref}
        backButtonText={backButtonText}
        subTitle={subTitle}
        title={title}
      />
    </PublicLayout>
  )
}

export default NotFoundPage
